import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // 常に最新データを取得
      gcTime: 0, // キャッシュを即座に破棄
      refetchOnWindowFocus: true, // ウィンドウフォーカス時にリフェッチ
      refetchOnMount: 'always', // マウント時に常にリフェッチ
      refetchOnReconnect: true, // 再接続時にリフェッチ
      retry: 1,
    },
    mutations: {
      onSuccess: () => {
        // mutation成功時に全てのクエリを即座にリフェッチ
        queryClient.invalidateQueries({ refetchType: 'all' });
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: {
              background: 'var(--background-card)',
              color: 'var(--text-primary)',
              border: '1px solid var(--border-color)',
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);


